import React from 'react';
import { CalendarDaysIcon, ClockIcon } from '@heroicons/react/24/outline';

const PlanCardSkeleton: React.FC = () => {
  return (
    <div className="rounded-lg font-myYekanFaNumRegular overflow-hidden bg-white border border-gray w-72 flex-shrink-0 flex flex-col h-full">
      {/* Image Section Skeleton */}
      <div className="relative h-48 w-full bg-gray-100">
        {/* Case 2: 4-grid layout skeleton (most common complex case) */}
        <div className="grid grid-cols-2 grid-rows-2 h-full w-full p-1">
          {[0, 1, 2, 3].map((index) => (
            <div
              key={index}
              className="relative overflow-hidden border border-white/20 p-1"
            >
              <div className="w-full h-full bg-gray-200 animate-pulse rounded-md" />
            </div>
          ))}
        </div>
        
        {/* Badge Skeleton */}
        <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-md shadow-sm z-10 flex items-center gap-1 w-20 h-5">
          <div className="w-3 h-3 bg-gray-200 rounded-full animate-pulse" />
          <div className="w-10 h-2 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>

      {/* Content Section Skeleton */}
      <div className="p-4 flex-1 flex flex-col">
        {/* Title Skeleton */}
        <div className="h-6 bg-gray-200 rounded w-3/4 mb-3 animate-pulse" />
        
        {/* Description Skeleton */}
        <div className="space-y-2 mb-4 h-8">
          <div className="h-2 bg-gray-200 rounded w-full animate-pulse" />
          <div className="h-2 bg-gray-200 rounded w-5/6 animate-pulse" />
        </div>

        {/* Steps Preview Skeleton */}
        <div className="mt-auto">
          {/* Divider Skeleton */}
          <div className="flex items-center justify-between mb-3 border-b pb-1">
            <div className="h-3 bg-gray-200 rounded w-12 animate-pulse" />
          </div>
          
          {/* Step Items Skeleton */}
          <div className="space-y-3">
            {[0, 1, 2].map((index) => (
              <div key={index} className="flex items-start gap-2">
                {/* Dot Skeleton */}
                <div className="min-w-[4px] h-4 rounded-full bg-gray-200 animate-pulse mt-0.5" />
                
                <div className="flex-1">
                  {/* Step Name & Time Row */}
                  <div className="flex justify-between items-center mb-1">
                    <div className="h-3 bg-gray-200 rounded w-24 animate-pulse" />
                    <div className="flex items-center gap-1">
                      <ClockIcon className="w-3 h-3 text-gray-300" />
                      <div className="h-2 bg-gray-200 rounded w-8 animate-pulse" />
                    </div>
                  </div>
                  {/* Activity Skeleton */}
                  <div className="h-2 bg-gray-200 rounded w-16 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCardSkeleton;